import { ReactElement, useEffect } from 'react'

import { getSignUpFormInvitationSuccess } from 'actions/auth'
import { LoadingIndicator } from 'components/LoadingIndicator'
import { acceptSignUpFormInvitation } from 'features/Auth/authService'
import {
    useMountPage,
    useMountingState,
    useAuthDomainValue,
    useAction,
} from 'hooks'
import { CobaltPath } from 'routing/Path'
import { OrganizationInvitation } from 'types'

import { useSignUpInvitationQuery } from './api/signUpInvitationQueries'
import { JoinOrganizationForm, CreateOrganizationForm } from './Forms'

const PAGE_PATH: CobaltPath = ['authOrganizationPage']

const AuthOrganizationPage = (): ReactElement => {
    useMountPage(PAGE_PATH[0])
    const mounting = useMountingState(PAGE_PATH[0])
    const email: string | undefined = useAuthDomainValue('email')
    const invitation: OrganizationInvitation = useAuthDomainValue('invitation')
    const setInvitation = useAction(getSignUpFormInvitationSuccess)

    const { data: pendingInvitations } = useSignUpInvitationQuery(email, {
        enabled: !!email && !invitation,
    })

    useEffect(() => {
        if (pendingInvitations && pendingInvitations.length > 0) {
            setInvitation(pendingInvitations[0])
        }
    }, [pendingInvitations, setInvitation])

    if (mounting) {
        return <LoadingIndicator size="small" />
    }

    return invitation ? (
        <JoinOrganizationForm
            invitation={invitation}
            onSubmit={acceptSignUpFormInvitation}
        />
    ) : (
        <CreateOrganizationForm />
    )
}

export default AuthOrganizationPage
